export class BrowserStorage {
    set(name, value) {
        if (this.isLocalStorageAvailable) localStorage.setItem(name, String(value));
    }
    get(name, defaultValue = null) {
        if (this.isLocalStorageAvailable) return localStorage.getItem(name);
        return defaultValue;
    }
    setJSON(name, value) {
        if (this.isLocalStorageAvailable) localStorage.setItem(name, JSON.stringify(value));
    }
    getJSON(name, defaultValue = null) {
        if (!this.isLocalStorageAvailable) return defaultValue;
        const raw = localStorage.getItem(name);
        if (raw == null) return defaultValue;
        try {
            return JSON.parse(raw);
        } catch  {
            return defaultValue;
        }
    }
    delete(name) {
        if (this.isLocalStorageAvailable) localStorage.removeItem(name);
    }
    constructor(){
        this.isLocalStorageAvailable = typeof localStorage !== 'undefined';
    }
}
